<div class="assignee-selector" [class.invalid]="isInvalid">
  <div class="selected-assignees" *ngIf="multiSelect && selectedAdmins.length > 0">
    <div class="selected-assignee-chip" *ngFor="let admin of selectedAdmins">
      <span class="assignee-chip-name">{{admin.name}}</span>
      <span class="remove-assignee" (click)="toggleAdminSelection(admin); $event.stopPropagation()">
        <mat-icon>close</mat-icon>
      </span>
    </div>
  </div>

  <div class="input-wrapper" (click)="toggleDropdown(); $event.stopPropagation()">
    <input 
      type="text" 
      class="assignee-input"
      [(ngModel)]="searchQuery" 
      (ngModelChange)="onSearchChange($event)"
      (click)="toggleDropdown(); $event.stopPropagation()"
      placeholder="{{ 'request_v2.assignee_selector.search_placeholder' | translate }}"
    >
    <div class="dropdown-icon">
      <mat-icon>{{ isVisible ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
    </div>
  </div>

  <div class="dropdown-panel" *ngIf="isVisible">
    <div class="loading-indicator" *ngIf="loading">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
    
    <div class="admin-list" *ngIf="!loading">
      <div class="admin-item" 
        *ngFor="let admin of filteredAdmins" 
        [class.selected]="isAdminSelected(admin.id)"
        (click)="onAssigneeSelect(admin)"
      >
        <div class="selection-indicator">
          <div *ngIf="multiSelect" class="checkbox" [class.checkbox-selected]="isAdminSelected(admin.id)"></div>
          
          <ng-container *ngIf="!multiSelect">
            <div class="checkbox-selected" *ngIf="isAdminSelected(admin.id)"></div>
            <div class="checkbox-empty" *ngIf="!isAdminSelected(admin.id)"></div>
          </ng-container>
        </div>
        
        <div class="admin-details">
          <div class="admin-name">{{ admin.name }}</div>
          <div class="admin-email">{{ admin.email }}</div>
        </div>
        <div class="admin-initials">
          <div class="initials-circle" *ngIf="!admin.picture">{{ admin.initials }}</div>
          <img *ngIf="admin.picture" [src]="admin.picture" class="admin-avatar" alt="{{ admin.name }}" />
        </div>
      </div>
      
      <div class="no-results" *ngIf="filteredAdmins.length === 0">
        {{ 'request_v2.assignee_selector.no_results' | translate }}
      </div>
    </div>
  </div>
</div> 

<div class="messages">
  <ng-content selector="app-form-error"></ng-content>
  <ng-content selector="app-form-success"></ng-content>
</div>
